import { useEffect,useState } from "react"
import axios from 'axios';
export function useFetch(url,body,token,method,server){
    const [data,setData]=useState([]);
    const [loading,setLoading]=useState(true);
    const [error,setError]=useState(null);
    const [statusError,setStatusError]=useState(false)
    token=localStorage.getItem('access_token')
   
    useEffect(() => {
      
      setLoading(true)
      const fetchData = async () => {
        
      // console.log(server.url+'/api/v1/zabbix/db/'+url+"/"+body)
        try {
          // console.log(server.url+'/api/v1/'+url+"/"+body)
          // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTE4NDI5MTd9.-qw7OFS4QYkgtglBByECAoEsHE2tiCwjkeaZLUyZMBw'; // Reemplaza con tu token de autenticación
          const response = await fetch(server.url+'/api/v1/'+url+"/"+body, {
            method: method,  
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
          // console.log(`Bearer ${token}`)
          if (response.ok) {
            
            const data1 = await response.json();
            setLoading(false)
            // Manejo de la respuesta
            setData(data1)
            setStatusError(false)
            // console.log(data1);
          } else {
            const data1 = await response.json();
            setStatusError(true)
            setLoading(false)

            throw new Error('Error en la solicitud');
          }
        } catch (error) {
          // Manejo de errores
          setStatusError(true)
          setError(true)
          console.error(error);
        }
      };
  
      fetchData();
    }, [url, body, method, server.url, token]);
return {data,loading,error,statusError}


  }

